import { useQuery } from "@apollo/client"
import { PastChallengesDocument } from "@artists/gql/design-challenges"
import { useTypedSearchParams } from "react-router-typesafe-routes/dom"

import { Root } from "../../../../utils"
import type { PastChallengeResponse } from "./past-challenges.types"

export const usePastChallenges = (): PastChallengeResponse => {
	const [{ offset, search }] = useTypedSearchParams(Root.Past)

	const { loading, data, previousData } = useQuery(PastChallengesDocument, {
		variables: { from: offset, search: search, limit: 52 },
	})

	return {
		loading,
		challenges: data?.challenges.results ?? [],
		pagination: {
			total:
				(data || previousData)?.challenges.info.pagination.total ?? 0,
			limit:
				(data || previousData)?.challenges.info.pagination.limit ?? 52,
		},
	}
}
